import YICUWinnerPage from "./YICUWinnerPage";

const CONTENT = {
  supportBanner: "Show your support! Like your nominee's announcement on Facebook, Instagram, or LinkedIn to help them win the Community Hero Award. You can also support their cause by donating on their behalf to help them win the Standing Ovation Award.",
  individualWinner: [


    { name: "Taylor Jordan", image: "/images/YICU/2025/Taylor Jordan.jpg", donateUrl: "https://givebutter.com/YICU2025/taylorjordan1" },
    { name: "Pranika Kurella", image: "/images/YICU/2025/Pranika kurella.jpg", donateUrl: "https://givebutter.com/YICU2025/pranikakurella" },
    { name: "Chloe Shapkauski", image: "/images/YICU/2025/Chloe Da.jpg", donateUrl: "https://givebutter.com/YICU2025/chloeshapkauski" },
    { name: "Rishabhakrishna Narendranath", image: "/images/YICU/2025/Rishabh Narendranath.jpg", donateUrl: "https://givebutter.com/YICU2025/rishabhakrishnanarendranath" },
    { name: "Colton Leonard", image: "/images/YICU/2025/Colton Leonard.jpg", donateUrl: "https://givebutter.com/YICU2025/coltonleonard" },
    { name: "Srinidhi Gurijala", image: "/images/YICU/2025/Srinidhi Gurijala.jpg", donateUrl: "https://givebutter.com/YICU2025/srinidhigurijala" },
    { name: "Oceane Mvita Ilebo", image: "/images/YICU/2025/oceane mvita ilebo.jpg", donateUrl: "https://givebutter.com/YICU2025/oceanemvitailebo" },
    { name: "Soumya Boyina", image: "/images/YICU/2025/Soumya Boyina.jpg", donateUrl: "https://givebutter.com/YICU2025/soumyaboyina" },
    { name: "Elliott Tolentino", image: "/images/YICU/2025/Elliott Tolentino.jpg", donateUrl: "https://givebutter.com/YICU2025/elliotttolentino" },
    { name: "Rhea Balakrishnan", image: "/images/YICU/2025/Rhea Balakrishnan.jpg", donateUrl: "https://givebutter.com/YICU2025/rheabalakrishnan" },
    { name: "Sanyah Carter", image: "/images/YICU/2025/Sanyah.jpg", donateUrl: "https://givebutter.com/YICU2025/sanyahcarter" },

  ],
  communityHeroAwardWinner: [
    { name: "Srinidhi Gurijala", image: "/images/YICU/2025/Srinidhi Gurijala.jpg", donateUrl: "https://givebutter.com/YICU2025/srinidhigurijala" },

  ],
  standingOvationAwardWinner: [
    { name: "Alexis Clark", image: "/images/YICU/2025/Alexis Clark.jpg", donateUrl: "https://givebutter.com/YICU2025/alexisclark1" },

  ],
  teamWinners: [
    { name: "Olympia High School National Honor Society", image: "/images/YICU/2025/Amanda Hapgood2.jpg" },
  ],
  advocateWinners: [
    { name: "Mentoring And Providing Scholarships (MAPS) Program", image: "/images/YICU/2025/Dr. Carla Campbell-Jackson.png" },
  ],
  mentorWinners: [
    { name: "Nora Zaring", image: "/images/YICU/2025/Hema Kasturi.jpg" },
  ],
};

export default function YICU() {
  return <YICUWinnerPage year="2025" content={CONTENT} />;
}